jQuery(document).ready(function ($) {
    const room_reviews_carousels = $('.room-reviews__carousel');

    room_reviews_carousels.each(function () {
        const $carousel = $(this);
        const $current = $carousel.find('.room-reviews__carousel--counter .current');

        const update_counter = function (swiper) {
            const slide_number = swiper.realIndex + 1;

            $current.text(String(slide_number).padStart(2, '0'));
        };

        const single_carousel = new Swiper(`#${$carousel.attr('id')}`, {
            loop: true,

            slidesPerView: 1,
            slidesPerGroup: 1,

            longSwipes: false,

            spaceBetween: 32,

            grabCursor: true,

            autoplay: true,
            delay: 8000,

            navigation: {
                prevEl: '.room-reviews__carousel--prev',
                nextEl: '.room-reviews__carousel--next'
            },

            on: {
                init: update_counter,
                slideChange: update_counter
            }
        });
    });
});
